var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlaneSimple = function SvgPlaneSimple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#1E1E1E",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M10.152 22.503a1.655 1.655 0 0 1-1.655-1.655v-6.345h-3.42l-1.365 2.4a1.185 1.185 0 0 1-2.215-.585v-8.63a1.185 1.185 0 0 1 2.215-.585l1.365 2.4h3.42V3.158a1.65 1.65 0 0 1 3.125-.75l3.605 7.095h4.77a2.5 2.5 0 0 1 0 5h-4.77l-3.605 7.095a1.65 1.65 0 0 1-1.47.905"
  })));
};
export default SvgPlaneSimple;